import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/* The boot backdrop (see public/index.html) is NOT retired here.
   `root.render()` only schedules work — React 19 commits concurrently, so a
   requestAnimationFrame straight after this line runs long before the hero has
   painted. Removing the backdrop there blanked the screen in between AND handed
   Largest Contentful Paint to React's own <img>, which is exactly what we are
   trying to avoid: measured LCP stayed at 7.5 s.
   Hero.js drops it after its first paint instead. */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
